import React, { memo, useEffect, useRef } from "react";
import { Box, Typography } from "@mui/material";
import { useSelector, useDispatch } from "react-redux";
import { fetchDashboardData } from "../../../store/dashboard/action";

const ProductFilterMobile = memo(({ categoryIds, setSearchParams }) => {
  const dispatch = useDispatch();
  const categories = useSelector((state) => state?.Dashboard?.categories);
  const categoryRefs = useRef({});

  useEffect(() => {

    if (!categories?.length) {
      dispatch(fetchDashboardData());
    }
  }, [categories, dispatch]);

  const handleToggle = (id) => {
    const selectedId = String(id);

    setSearchParams((prev) => {
      const params = new URLSearchParams(prev);
      if (categoryIds.includes(selectedId)) {
        params.delete("categoryIds[]");
      } else {
        params.set("categoryIds[]", selectedId);
      }
      return params;
    });
  };

  useEffect(() => {
    if (!categoryIds?.length) return;
    const selectedId = categoryIds[0];
    const selectedElement = categoryRefs.current[selectedId];
    if (selectedElement) {
      selectedElement.scrollIntoView({
        behavior: "smooth",
        inline: "center",
        block: "nearest",
      });
    }
  }, [categoryIds]);

  return (
    <Box
      sx={{
        width: "100%",
        borderRadius: "12px",
        overflow: "hidden",


      }}
    >
      <Box
        sx={{
          display: "flex",
          gap: 1,
          py: 1,
          overflowX: "auto",
          overflowY: "hidden",
          flexWrap: "nowrap",
          "&::-webkit-scrollbar": { display: "none" },
          scrollbarWidth: "none",
        }}
      >
        {[...(categories || [])]?.reverse()?.map((category) => {
          const isSelected = categoryIds?.includes(String(category?.id));
          return (
            <Box
              key={category?.id}
              ref={(el) => {
                categoryRefs.current[String(category?.id)] = el;
              }}
              onClick={() => handleToggle(category?.id)}
              sx={{
                display: "flex",
                alignItems: "center",
                gap: 1,
                maxWidth: "calc(50% - 4px)",
                width: "fit-content",
                px: 1.5,
                py: 1,
                borderRadius: "12px",
                border: "1px solid #E4C18F",
                backgroundColor: isSelected ? "#E4C18F" : "#fff",
                cursor: "pointer",
              }}
            >
              <Box
                component="img"
                src={category?.logo}
                alt={category?.name}
                sx={{ width: 28, height: 28, borderRadius: "50%", objectFit: "cover" }}
              />
              <Typography
                sx={{
                  fontSize: "12px",
                  fontWeight: 500,
                  fontFamily: "Be Vietnam Pro",
                  color: isSelected ? "primary.main" : "#000",
                  textTransform: "capitalize",
                }}
              >
                {category?.name}
              </Typography>
            </Box>
          );
        })}
      </Box>
    </Box>
  );
});

export default ProductFilterMobile;